import { IInvoiceDTO, IRequestDTO } from "@/interface"
import { Invoice } from "@/models/invoice/invoice"
import { Pagination } from "@/models/commons/pagination"

export class Invoices {
    public pagination: Pagination | null;
    public data: (Invoice | null)[] | null;
    public path: string

    constructor(base: Invoices) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IRequestDTO<IInvoiceDTO>, isPaid: boolean):Invoices | null {
        if (!dto) {return null;}
        return new Invoices({
            pagination: dto ? Pagination.fromDto(dto) : null,
            data: dto.data && dto.data.length > 0 ? dto.data.map(data => Invoice.fromDto(data, isPaid)) : null,
            path: dto.path
        });
    }
}

